import React, { useState, useEffect } from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { AppBar } from "@mui/material";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { FiChevronRight } from "react-icons/fi";
import styles from "./jobs.module.scss";
import { MdBusinessCenter } from "react-icons/md";
import { BsPersonFill } from "react-icons/bs";
import { FaDollarSign, FaMapMarkerAlt } from "react-icons/fa";
import { capitalizeFirstLetter, numFormatter } from "@unisearch/helpers";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#fff",
  },
}));

export const CareerJobs = ({ jobs }) => {
  const classes = useStyles();

  const [activeTab, setActieValue] = React.useState(0);

  const [category, setCategory] = useState();

  const handleChange = (event, newValue) => {
    setActieValue(newValue);
  };

  useEffect(() => {
    if (jobs.length > 0) {
      const uniqueCategory = [
        ...new Set(jobs.map((item) => item.categoryName)),
      ];

      setCategory(uniqueCategory);
      // let tabs = jobs.filter()
    } else {
      setCategory([]);
    }
  }, [jobs]);

  return (
    <section className={styles.section_jobs} id="jobs">
      <div className="container">
        <div className={styles.heading_wrapper}>
          {jobs.length > 0 ? (
            <h2 className={styles.heading}>Available Jobs</h2>
          ) : (
            <h2 className={styles.heading}>No Jobs Available !!</h2>
          )}
        </div>

        <div className="uni_campuses ">
          <div className={classes.root}>
            <AppBar
              position="static"
              color="default"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {jobs.length > 0 && (
                <Tabs
                  value={activeTab}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs example"
                >
                  <Tab label="All" {...a11yProps(0)} />
                  {category &&
                    category.map((item, index) => {
                      return (
                        <Tab
                          label={capitalizeFirstLetter(item)}
                          {...a11yProps(index + 1)}
                          key={`tab${item}`}
                        />
                      );
                    })}
                </Tabs>
              )}
            </AppBar>

            <TabPanel value={activeTab} index={0}>
              <div className={styles.jobs_wrapper}>
                <ul className={styles.jobs_lists}>
                  {jobs?.map((item, i) => (
                    <li key={i} className={styles.job_list}>
                      <div className={styles.job_description_wrapper}>
                        <Link legacyBehavior href={`/career/${item?.slug}`}>
                          <a>
                            <h4 className={styles.job_title}>
                              {item?.careerTitle}
                            </h4>
                          </a>
                        </Link>
                        <ul className={styles.job_shor_info}>
                          <li>
                            <MdBusinessCenter />
                            <span>{item?.categoryName}</span>
                          </li>
                          <li>
                            <BsPersonFill />
                            <span>{item?.vacancy}</span>
                          </li>
                          <li>
                            <FaMapMarkerAlt />
                            <span>{item?.countryName}</span>
                          </li>
                          <li>
                            <FaDollarSign />
                            <span>
                              {item?.currencySymbol}
                              {item?.salaryRangeMin
                                ? numFormatter(item?.salaryRangeMin)
                                : ""}{" "}
                              - {item?.currencySymbol}
                              {item?.salaryRangeMax
                                ? numFormatter(item?.salaryRangeMax)
                                : ""}{" "}
                              / {item?.salaryType}
                            </span>
                          </li>
                        </ul>
                        <div className={styles.job_status_wrapper}>
                          <div className={`${styles.status} ${styles.inter}`}>
                            {item?.careerType}
                          </div>
                          {/* 
                          <div className={`${styles.status} ${styles.urgent}`}>
                            Urgent
                          </div> */}
                        </div>
                      </div>
                      <Link legacyBehavior href={`/career/${item?.slug}`}>
                        <a className={styles.link}>
                          <FiChevronRight />
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </TabPanel>

            {category &&
              category.map((item, index) => {
                return (
                  <TabPanel
                    value={activeTab}
                    index={parseInt(index + 1)}
                    key={item}
                  >
                    <div className={styles.jobs_wrapper}>
                      <ul className={styles.jobs_lists}>
                        {jobs
                          .filter((job, i) => job?.categoryName === item)
                          .map((item, i) => (
                            <li
                              key={`${item.careerPostId}_${i}`}
                              className={styles.job_list}
                            >
                              <div className={styles.job_description_wrapper}>
                                <Link
                                  legacyBehavior
                                  href={`/career/${item?.slug}`}
                                >
                                  <a>
                                    <h4 className={styles.job_title}>
                                      {item?.careerTitle}
                                    </h4>
                                  </a>
                                </Link>
                                <ul className={styles.job_shor_info}>
                                  <li>
                                    <MdBusinessCenter />
                                    <span>{item?.categoryName}</span>
                                  </li>
                                  <li>
                                    <BsPersonFill />
                                    <span>{item?.vacancy}</span>
                                  </li>
                                  <li>
                                    <FaMapMarkerAlt />
                                    <span>{item?.countryName}</span>
                                  </li>
                                  <li>
                                    <FaDollarSign />
                                    <span>
                                      {item?.currencySymbol}
                                      {item?.salaryRangeMin
                                        ? numFormatter(item?.salaryRangeMin)
                                        : ""}{" "}
                                      - {item?.currencySymbol}
                                      {item?.salaryRangeMax
                                        ? numFormatter(item?.salaryRangeMax)
                                        : ""}{" "}
                                      / {item?.salaryType}
                                    </span>
                                  </li>
                                </ul>
                                <div className={styles.job_status_wrapper}>
                                  <div
                                    className={`${styles.status} ${styles.inter}`}
                                  >
                                    {item?.careerType}
                                  </div>

                                  {/* <div
                                    className={`${styles.status} ${styles.urgent}`}
                                  >
                                    Urgent
                                  </div> */}
                                </div>
                              </div>
                              <Link
                                legacyBehavior
                                href={`/career/${item?.slug}`}
                              >
                                <a className={styles.link}>
                                  <FiChevronRight />
                                </a>
                              </Link>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </TabPanel>
                );
              })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerJobs;
